import { render, staticRenderFns } from "./FeesGraphs.vue?vue&type=template&id=a6f148f8"
import script from "./FeesGraphs.vue?vue&type=script&lang=js"
export * from "./FeesGraphs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports